var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('util-tab-title',{attrs:{"title":"Pencatatan Terakhir","action":"/utilities/gas"}}),_c('util-chart',{attrs:{"chartdata":_vm.chart}}),(_vm.group == 'Operator Utilities')?_c('util-add',{attrs:{"action":"/utilities/gas/add"}}):_vm._e(),_c('util-item-gas',{attrs:{"listdata":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }